import { render, staticRenderFns } from "./listOfNews.vue?vue&type=template&id=6621ee93&"
import script from "./listOfNews.vue?vue&type=script&lang=js&"
export * from "./listOfNews.vue?vue&type=script&lang=js&"
import style0 from "./listOfNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports